import { plainToClass } from 'class-transformer';
import {
  API_NEWS_CREATE,
  API_NEWS_DELETE,
  API_NEWS_FIND_ALL,
  API_NEWS_FIND_ONE,
  API_NEWS_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { NewsDto } from '../dto';
import { FindAllResponse } from '../types';

export class NewsApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<NewsDto>> {
    return this.httpClient
      .get(API_NEWS_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(NewsDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<NewsDto> {
    return this.httpClient
      .get(API_NEWS_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(NewsDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<NewsDto> {
    return this.httpClient.post(API_NEWS_CREATE, data).then(({ data }) => {
      return plainToClass(NewsDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<NewsDto> {
    return this.httpClient.put(API_NEWS_UPDATE, data).then(({ data }) => {
      return plainToClass(NewsDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_NEWS_DELETE, {
      pathParams: { uuid }
    });
  }
}
